/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { globalBreak } from '@/styles/break';
import { resBreak } from '@/utils/resBreak';
import { SxProps, Theme } from '@mui/material';

export const headerContainerSX: SxProps<Theme> = (theme: Theme) => ({
	boxShadow: 0,
	borderRadius: 0,
	top: 0,
	position: headerBreak({ mobile: 'sticky', desktop: 'relative' }),
	zIndex: headerBreak({ mobile: `${theme.zIndex.appBar}`, desktop: 'unset' }),
	display:'flex',
	justifyContent:'center',
	flexDirection:'column',
	'& >.MuiContainer-root':{
		bgcolor: headerBreak({ mobile: 'navbar.primary', desktop:'white'}),
		'& >.MuiStack-root':{
			height: headerBreak({ mobile:'60px', desktop:'72px'})
		}
	},
	overflow: 'unset',
	bgcolor:'navbar.primary',
	'& > .MuiContainer-root':{
		bgcolor:'navbar.primary',
	}

});
export const headerLogoSearchStackSX:SxProps ={
	columnGap: resBreak<'column-gap'>({ mobile: 0, desktop: 2, tablet:2 }),
	'& .header-store-logo':{
		m:0,
		display:'flex',
		'& a':{
			display:'flex',
			alignItems:'center'
		},
		'& img':{
			position: resBreak<'relative' | 'absolute'>({ mobile: 'absolute', desktop: 'relative', tablet:'relative' }),
			width:resBreak<'width'>({mobile:'11rem', desktop:'14rem'}),
			height: 'auto',
		}
	},
}

export const checkoutheaderContainerSX:SxProps ={
	backgroundColor:'#fd0',
	py:globalBreak({mobile:0.5, desktop:1}),
	'& a':{
		display:'flex',
		alignItems:'center'
	},
	'& img':{
		height: 'auto',
	},
	borderRadius:'0'
}

export const headerPlayButtonSX:SxProps = {
	display:headerBreak({mobile:'none',desktop:'flex'}),
	color: '#000', 
	padding:'1px',
	fontSize:'14px !important',
	width: '7em', 
	letterSpacing:1.5,
	alignItems: 'center', 
	columnGap: 1, 
	bgcolor: '#fd0', 
	borderRadius: '5px', 
	'&:hover': {
		bgcolor: '#fd0',
		color: '#000',
	},
	'& > svg':{
		fontSize:14,
		strokeWidth: 1,
		stroke: '#000'
	},
}

export const headerPlayButtonMobSX:SxProps = { 
	display:headerBreak({mobile:'flex',desktop:'none'})
}

export const winkelsCustServiceLinksSX:SxProps = {
	display:headerBreak({mobile:'none',desktop:'flex'}),
	alignItems:'center',
	flexDirection:'row',
	justifyContent:'space-between',
	columnGap:'15px',
	fontSize:14
}

export const winkelsCustServiceLinksMobSX:SxProps = {
	display:headerBreak({mobile:'flex',desktop:'none'}),
	flexDirection:'column',
	alignItems: 'flex-start',
	rowGap:2,
	fontSize:16,
	fontWeight:500
}
